import Lottie from "lottie-web";
export default () => ({
    show: false,

    init() {
        lottie
    },

    trigger_menu: {
        ["@click.prevent"](){
            this.show = !this.show;

            if(this.show){
                lottie.setDirection(1);
                lottie.play();
            }else{
                lottie.setDirection(-1);
                lottie.addEventListener('data_ready', function(){lottie.frameRate = 60});
                lottie.play();
            }
        },
        ["x-trap.noscroll"](){
            return this.show;
        },
        ["@keydown.escape"](){
            this.show = false;
        },
    },

    show_menu: {
        ["x-show"]() {
            return this.show;
        },
        ["@keydown.escape"](){
            this.show = false;
        }
    }
})

let menu = document.querySelector('.lottie_menu'),
    menu_file = ajax_object.url + '/assets/images/lottie/cross.json';

const lottie = new Lottie.loadAnimation({
    container: menu,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path : menu_file
})